<template>
    <template v-if="inline">
        <slot></slot>
    </template>
    <template v-else-if="mounted">
        <teleport :to="appendTo">
            <slot></slot>
        </teleport>
    </template>
</template>

<script setup lang="ts">
    import { computed, onMounted, ref } from 'vue';

    type Props = {
        appendTo?: string;
        disabled?: boolean;
    };

    const { appendTo = '#dialogs', disabled = false } = defineProps<Props>();

    const mounted = ref(false);

    const inline = computed(() => {
        return disabled || appendTo === 'self';
    });

    onMounted(() => {
        mounted.value = true;
    });
</script>
